<template>
  <div class="vd_wrap">
    <el-row>
      <el-col :md="8">
        <el-form-item :rules="!disableMtrlAdd ? [{ required: true, message: ' ' }] : [{ required: false }]" label="物料图片" prop="imge_id">
          <el-upload
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
            :data="dataBody"
            :disabled="disableMtrlAdd"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            accept=".jpg,.jpeg,.png"
            class="avatar-uploader"
          >
            <el-image v-if="qrcdForm.imge_id" :src="qrcdForm.imge_url" :preview-src-list="[qrcdForm.imge_urlO]" fit="cover" class="avatar"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon vg_pointer"></i>
          </el-upload>
          <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span>
        </el-form-item>
      </el-col>
      <el-col :md="8">
        <el-form-item label="安全库存" prop="mtrl_stock_limit">
          <el-input
            v-model="qrcdForm.mtrl_stock_limit"
            :disabled="disableMtrlAdd"
            maxlength="7"
            placeholder="请填写库存警告数量"
            show-word-limit
            @input="qrcdForm.mtrl_stock_limit = helper.keepTNum(qrcdForm.mtrl_stock_limit)"
          ></el-input>
        </el-form-item>
        <el-form-item label="物料单价" prop="mtrl_prod_price">
          <el-input
            v-model="qrcdForm.mtrl_prod_price"
            maxlength="11"
            placeholder="请填写物料单价"
            show-word-limit
            @blur="qrcdForm.mtrl_prod_price = helper.calcPrice(qrcdForm.mtrl_prod_price, 7, 1000000)"
            @input="qrcdForm.mtrl_prod_price = helper.keepTNum1(qrcdForm.mtrl_prod_price)"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="物料单位" prop="mtrl_unit">
          <el-select v-model="qrcdForm.mtrl_unit" :disabled="disableMtrlAdd" clearable placeholder="请选择物料单位">
            <el-option v-for="item in mtrlTypeGroupOpt" :key="item.id" :label="item.param1" :value="item.param1"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="8">
        <el-form-item label="物料成分" prop="mtrl_comp">
          <el-select v-model="qrcdForm.mtrl_comp" :disabled="disableMtrlAdd" clearable filterable placeholder="请选择物料成分">
            <el-option v-for="item in compType" :key="item.id" :label="item.param1" :value="item.param1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他备注" prop="mtrl_remark">
          <el-input
            v-model="qrcdForm.mtrl_remark"
            :disabled="disableMtrlAdd"
            maxlength="150"
            placeholder="请填写物料备注"
            rows="1"
            show-word-limit
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item
          :rules="qrcdForm.mtrl_type !== 0 ? [{ required: true, message: ' ' }] : [{ required: false }]"
          label="物料规格"
          prop="mtrl_spec"
        >
          <el-input
            v-model="qrcdForm.mtrl_spec"
            :disabled="disableMtrlAdd"
            maxlength="50"
            placeholder="请填写物料规格"
            rows="1"
            show-word-limit
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="8">
        <el-form-item label="克重图片" prop="gram_weight_id">
          <el-upload
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
            :data="dataBody"
            :on-success="handleWeightAvatarSuccess"
            :show-file-list="false"
            accept=".jpg,.jpeg,.png"
            class="avatar-uploader"
          >
            <el-image v-if="qrcdForm.gram_weight_id" :src="qrcdForm.gram_weight_url" :preview-src-list="[qrcdForm.gram_weight_urlO]" fit="cover" class="avatar"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon vg_pointer"></i>
          </el-upload>
          <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { get } from '@api/request';
import { optnAPI } from '@api/modules/optn';
import { imgeAPI } from '@api/modules/imge';

export default {
  name: 'mtrlAddMain',
  components: {},
  props: {
    qrcdForm: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    },
    disableMtrlAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      uploadUrl: this.helper.modePrepend(imgeAPI.uploadImage),
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      mtrlTypeGroupOpt: [],
      compType: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMtrlType();
      this.getCompType();
    },
    // 通用请求处理
    fetchOptions(api, params, targetKey) {
      get(api, params)
        .then(res => {
          if (res.data.code === 0) {
            this[targetKey] = res.data.data;
          } else {
            this.$message({ message: res.data.msg, type: 'error' });
          }
        })
        .catch(err => {
          this.$message({ message: err, type: 'error' });
        });
    },
    // 获取成分
    getCompType() {
      this.fetchOptions(optnAPI.getAllContent, { perm_id: 10008 }, 'compType');
    },
    // 获取单位
    getMtrlType() {
      this.fetchOptions(optnAPI.getAllContent, { perm_id: 10005 }, 'mtrlTypeGroupOpt');
    },
    // 成功上传物料图片
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        let updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        let urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.qrcdForm.imge_id = res.data.imge_id;
        this.qrcdForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.qrcdForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        this.$message({ message: res.msg, type: 'error' });
      }
    },
    // 成功上传克重图片
    handleWeightAvatarSuccess(res) {
      if (res.code === 0) {
        this.qrcdForm.gram_weight_id = res.data.imge_id;
        this.qrcdForm.gram_weight_url = res.data.imge_url;
        this.qrcdForm.gram_weight_urlO = res.data.imge_url;
      } else {
        this.$message({ message: res.msg, type: 'error' });
      }
    },
    // 上传头像前
    beforeAvatarUpload() {}
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader ::v-deep .el-upload--text {
  width: 136px;
  height: 136px;
}
.avatar-uploader .el-upload:hover {
  border-color: $color-primary;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: $color-uploader-icon;
  width: 136px;
  height: 136px;
  line-height: 136px;
  text-align: center;
}
.vd_wrap {
  margin-top: 2px;
}
</style>
